import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { HlAppMode } from '@/models/hl-app/hl-app-mode'
import { ApiService } from '@/services/api/service'
import { InitializeSession } from '@/services/session/initialize-session'
import { ApiClient } from './client'

const namespace: string = 'auto-load'

export class AutoLoginService extends ApiService {
  private readonly via: string | undefined

  constructor(appId?: string) {
    super(appId)

    this.via = this.getVia()
  }

  async autoLogin(userKey: string, hash: string, site: string): Promise<Either<Error, any>> {
    try {
      return await InitializeSession.onInitialized(async () => {
        const response = await ApiClient
          .get('/api/auto-login')
          .query({
            o: userKey,
            hash,
            site,
            ...(this.via ? { via: this.via } : {}),
          })

        log.debug({ service: `${namespace}/login`, response })

        return new Right(response)
      })
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }

  private getVia(): string | undefined {
    if (HlAppMode.isPageForHlApp) {
      return 'hlapp'
    }

    return undefined
  }
}
